/**
 * Copyright (c) 2020 Siemens Inc.
 * Unpublished - All rights reserved
 * 
 */
import React from 'react';
import './App.css';
import DecodeLicensingView from './views/decode-licensing-view';

function App() {
  return (
    <div className="container">
      <DecodeLicensingView />
    </div>
  );
}

export default App;
